(() => {
  'use strict';
  function formatGiftMoney(cents, currency, showCurrency) {
    if (!Number.isSafeInteger(cents) || currency !== 'INR') return null;
    const value = new Intl.NumberFormat('en-IN', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    return showCurrency ? value + ' ' + currency : value;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { formatGiftMoney };
  if (typeof customElements === 'undefined' || customElements.get('pp-cart-money')) return;
  customElements.define('pp-cart-money', class extends HTMLElement {
    connectedCallback() {
      const value = formatGiftMoney(Number(this.dataset.cents), this.dataset.currency, this.dataset.showCurrency === 'true');
      if (value) this.textContent = value;
    }
  });
})();
